// pt-PT source of truth for the auth area (login, self-registration, landing).
export const auth = {
  login: {
    logoAlt: 'Logótipo',
    subtitle: 'Área de gestão — inicie sessão.',
    configLoadError: 'Não foi possível carregar a configuração; a mostrar as opções por omissão.',
    signInFailed: 'Não foi possível iniciar sessão.',
    urlError: 'Não foi possível iniciar sessão. Tente novamente ou contacte o suporte.',
    entraButton: 'Entrar com Microsoft 365',
    localDivider: 'ou conta local (staging)',
    username: 'Utilizador',
    password: 'Palavra-passe',
    signIn: 'Entrar',
    signingIn: 'A entrar…',
  },
  iamnew: {
    needInvite: 'Este formulário requer um convite. Peça um link à equipa do CIIMAR.',
    inviteInvalid: 'O convite não é válido ou expirou.',
    submitError: 'Ocorreu um erro. Tente novamente.',
    validating: 'A validar o convite…',
    unavailableTitle: 'Convite indisponível',
    doneTitle: 'Obrigado!',
    doneBody:
      'O seu registo foi submetido e será revisto pela equipa de onboarding do CIIMAR. Caso seja necessário ajustar alguma informação, será contactado por email.',
    title: 'Registo de novo membro — CIIMAR',
    invitedBy: 'Convidado por {name}. ',
    fillIn: 'Preencha os seus dados. Os campos marcados com * são obrigatórios.',
    fullName: 'Nome completo *',
    email: 'Email *',
    phone: 'Telefone',
    startDate: 'Data de início',
    jobTitle: 'Função / cargo',
    department: 'Departamento',
    researchGroup: 'Grupo de investigação',
    notes: 'Notas',
    extraTitle: 'Informação adicional',
    submit: 'Submeter registo',
    submitting: 'A submeter…',
  },
  landing: {
    title: 'Registo — CIIMAR',
    subtitle: 'Vai iniciar funções no CIIMAR? Introduza o código que lhe forneceram.',
    codeLabel: 'Código de registo',
    codePlaceholder: 'Ex.: ABCD2345',
    continue: 'Continuar',
    memberPrompt: 'É membro do CIIMAR?',
    enterPortal: 'Entrar no Portal',
  },
};
